import ErrorPageComponent from './ErrorPage.component';

export * from "./ErrorPage.component";
export default ErrorPageComponent;